import { useCallback } from 'react';
import useOpenDrawerSettings from './useOpenDrawerSettings';

export const useOpenSplitTestDrawer = ({ splitTestId }: { splitTestId: string }) => {
  const { openDrawerSettings } = useOpenDrawerSettings();

  return useCallback(() => openDrawerSettings(splitTestId, 'split-test-settings'), [splitTestId, openDrawerSettings]);
};
